
export const formatCurrency = (value, showSign = false) => {
  const numValue = parseFloat(value);
  const isPositive = numValue > 0;
  const prefix = showSign && isPositive ? '+' : '';
  return `${prefix}₹${Math.abs(numValue).toFixed(2)}`;
};

export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    console.error('Failed to copy to clipboard:', error);
    return false;
  }
};

export const openInNewTab = (url) => {
  window.open(url, '_blank', 'noopener,noreferrer');
};

export const getUserInitials = (name) => {
  if (!name) return 'U';
  return name.charAt(0).toUpperCase();
};

export const getFirstName = (name) => {
  if (!name) return 'User';
  return name.split(' ')[0];
};

